import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  removeCurrency,
  getPortfolioData,
} from "../../../redux/actions.portfolio";
import { BsFillBriefcaseFill } from "react-icons/bs";
import ModalTable from "./ModalTable";
import styles from "../Header.module.scss";
import PortfolioInfo from "./PortfolioInfo";
import { MdRemoveCircle } from "react-icons/md";

const HeaderModal = () => {
  const dispatch = useDispatch();
  const [lgShow, setLgShow] = useState(false);
  const { portfolioData } = useSelector((state) => state.portfolio);

  const deleteFromPortfolio = (currency) => {
    dispatch(removeCurrency(currency));
  };

  const updatePortfolioData = (data) => {
    dispatch(getPortfolioData(data));
  };

  const portfolioToRender = [...portfolioData]
    .sort((a, b) => +a.rank - +b.rank)
    .map((currency) => (
      <tr key={currency.rank}>
        <td>{currency.rank}</td>
        <td>{currency.symbol}</td>
        <td>{currency.name}</td>
        <td>{Number(currency.amount).toFixed(2)}</td>
        <td>{+Number(currency.priceUsd).toFixed(2)}$</td>
        <td>{+Number(currency.changePercent24Hr).toFixed(2)}%</td>
        <td onClick={() => deleteFromPortfolio(currency)}>
          <MdRemoveCircle className={styles.removeButton} />
        </td>
      </tr>
    ));

  const portfolioPrice = [...portfolioData].reduce(
    (totalPrice, currency) =>
      totalPrice + +currency.amount * +currency.priceUsd,
    0
  );

  const portfolioStartPrice = [...portfolioData].reduce(
    (totalPrice, currency) =>
      totalPrice + +currency.amount * +currency.startPrice,
    0
  );

  useEffect(() => {
    dispatch(getPortfolioData(portfolioData));
  }, []);

  useEffect(() => {
    if (portfolioData) {
      localStorage.setItem("portfolio", JSON.stringify(portfolioData));
    }
  }, [portfolioData]);

  return (
    <>
      <Button
        variant="outline-info"
        onClick={() => setLgShow(true)}
        className={styles.portfolioButton}
      >
        <BsFillBriefcaseFill className={styles.portfolioIcon} />
      </Button>
      <Modal
        size="lg"
        show={lgShow}
        onHide={() => setLgShow(false)}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-lg">
            <PortfolioInfo
              portfolioPrice={portfolioPrice}
              portfolioStartPrice={portfolioStartPrice}
              updatePortfolioData={updatePortfolioData}
              portfolioData={portfolioData}
              lgShow={lgShow}
            />
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ModalTable portfolioToRender={portfolioToRender} />
        </Modal.Body>
      </Modal>
      <PortfolioInfo
        portfolioPrice={portfolioPrice}
        portfolioStartPrice={portfolioStartPrice}
        updatePortfolioData={updatePortfolioData}
        portfolioData={portfolioData}
      />
    </>
  );
};

export default HeaderModal;
